import React from 'react'

import clsx from 'clsx'

import classes from './Placeholder.module.scss'

/** @type {import("./types").default} */
const Placeholder = ({ className, ...props }) => {
  return <div className={clsx('Placeholder', classes.root, className)} {...props} />
}

export default Placeholder
